import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from './history';
import homeReducer from '../features/home/redux/reducer';
import commonReducer from '../features/common/redux/reducer';
import editorReducer from '../features/editor/redux/reducer';
import tutorialReducer from '../features/tutorial/redux/reducer';

const reducerMap = {
  router: connectRouter(history),
  home: homeReducer,
  common: commonReducer,
  editor: editorReducer,
  tutorial: tutorialReducer,
};

export default combineReducers(reducerMap);
